import { Viewport, type ViewportLiteral } from "../pixel-accessor";
import type { OutputViewportResolver } from "./OutputViewportResolver";
import type { ImageAdapter } from "../image-adapter";
import type { ReversePixelMapper } from "../pixel-mapper";
import type { OutputViewportStrategiesPool } from "./OutputViewportStrategiesPool";

/**
 * Base implementation of OutputViewportResolver interface.
 */
export class BaseOutputViewportResolver implements OutputViewportResolver {
  /**
   * BaseOutputViewportResolver constructor.
   *
   * @param outputViewportStrategiesPool
   */
  constructor(
    private readonly outputViewportStrategiesPool: OutputViewportStrategiesPool
  ) {}

  /**
   * @inheritDoc
   */
  resolve(
    image: ImageAdapter<unknown>,
    reversePixelMapper: ReversePixelMapper,
    viewport: "bestFit" | boolean | ViewportLiteral
  ): Viewport {
    const strategies = this.outputViewportStrategiesPool.items();
    strategies.sort((a, b) => a.priority - b.priority);
    const strategy = strategies.find((s) =>
      s.match(reversePixelMapper, viewport)
    );
    if (!strategy) {
      throw new Error(
        "Couldn't find matching output viewport resolution strategy"
      );
    }
    return strategy.getOutputViewport(image, reversePixelMapper, viewport);
  }
}
